import React from 'react';
import { Component, ComponentType } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';

import { Button, Card, Nav, ButtonGroup } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';

import BCard from '../../../framework/component/container/BCard';

interface TimeoutProps {
    location?: {
        state?: {
            quizId?: number;
            timeLimit?: number;
        };
    };
}

const PAGE_TITLE = "AMS - Test";

class Timeout extends Component<TimeoutProps> {

    constructor(props: TimeoutProps) {
        super(props);
    }

    componentDidMount() {
        document.title = PAGE_TITLE;
    }

    render() {
        const { state } = this.props.location || {};

        if (state) {
            return <BCard title="Timeout"
                contentPanel={<>
                    You have exceeded the {state.timeLimit}-minute timer for this test.
                </>}
                bottomPanel={
                    <ButtonGroup>
                        <NavLink to={`/quiz/${state?.quizId}`} className="nav-link" style={{ marginRight: '10px' }}>
                            <Button variant="primary">Retry test</Button>
                        </NavLink>
                        <Nav.Link eventKey="home" href="/ams/resProfile">
                            <Button variant="primary">Return to Profile</Button>
                        </Nav.Link>
                    </ButtonGroup>
                } />
        } else {
            return (
                <Card style={{ width: '18rem' }}></Card>
            );
        }
    }
}

const withNavigation = <P extends object>(WrappedComponent: ComponentType<P>) => {
    return (props: P) => {
        const navigate = useNavigate();
        const location = useLocation();
        const params = useParams();
        return <WrappedComponent {...props} navigate={navigate} location={location} params={params} />;
    };
};

export default withNavigation(Timeout);
